// extracted by mini-css-extract-plugin
export default {"card":"listticket_card__q9Cyd"};